<svg class="icon"
     [ngClass]="iconName"
     [attr.viewBox]="viewBox"
     [style]="style">
  <use [attr.xlink:href]="'#' + iconName"></use>
</svg>
